import { put, takeLatest, throttle } from 'redux-saga/effects';

import HospitalAPI from 'lib/api/HospitalAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import { openSnackbar } from 'features/snackbar';
import {
  GET_MY_DOCTOR_DATA,
  GET_DOCTOR_LIST,
  GET_SUMMARIZE_DOCTOR_LIST,
  UPDATE_DOCTOR_PROFILE,
  DELETE_DOCTOR_HOLIDAY,
  DELETE_DOCTOR_TIME,
  GET_DOCTOR_DETAIL,
  CREATE_DOCTOR_PROFILE,
} from '.';

const getDoctorListSaga = createRequestSaga(
  GET_DOCTOR_LIST,
  HospitalAPI.getDoctorList,
);
const getMyDoctorDataSaga = createRequestSaga(
  GET_MY_DOCTOR_DATA,
  HospitalAPI.getMyDoctorData,
);
const getSummarizeDoctorListSaga = createRequestSaga(
  GET_SUMMARIZE_DOCTOR_LIST,
  HospitalAPI.getSummarizeDoctorList,
);
const getDoctorDetailSaga = createRequestSaga(
  GET_DOCTOR_DETAIL,
  HospitalAPI.getDoctorDetail,
);
const createDoctorProfileSaga = createRequestSaga(
  CREATE_DOCTOR_PROFILE,
  HospitalAPI.createDoctorProfile,
  function* () {
    yield put(openSnackbar('등록되었습니다'));
  },
);
const updateDoctorProfileSaga = createRequestSaga(
  UPDATE_DOCTOR_PROFILE,
  HospitalAPI.updateDoctorProfile,
  function* () {
    yield put(openSnackbar('수정되었습니다'));
  },
);
const deleteDoctorHolidaySaga = createRequestSaga(
  DELETE_DOCTOR_HOLIDAY,
  HospitalAPI.deleteDoctorHoliday,
);
const deleteDoctorTimeSaga = createRequestSaga(
  DELETE_DOCTOR_TIME,
  HospitalAPI.deleteDoctorTime,
);

export default function* doctorsSaga() {
  yield throttle(1000, GET_DOCTOR_LIST, getDoctorListSaga);
  yield throttle(1000, GET_MY_DOCTOR_DATA, getMyDoctorDataSaga);
  yield throttle(1000, GET_DOCTOR_DETAIL, getDoctorDetailSaga);
  yield takeLatest(GET_SUMMARIZE_DOCTOR_LIST, getSummarizeDoctorListSaga);
  yield takeLatest(CREATE_DOCTOR_PROFILE, createDoctorProfileSaga);
  yield takeLatest(UPDATE_DOCTOR_PROFILE, updateDoctorProfileSaga);
  yield takeLatest(DELETE_DOCTOR_HOLIDAY, deleteDoctorHolidaySaga);
  yield takeLatest(DELETE_DOCTOR_TIME, deleteDoctorTimeSaga);
}
